import React from 'react';
import Navigation from 'gatsby-core-theme/src/components/organisms/navigation';

export default (props) => {  
  const customClass = props.template === 'operator_review' ? 'bottom' : ''
  return <Navigation {...props} logoWidth={235} logoHeight={60} logo = '/images/logo.png' customStyles={customClass} hasCustomComponent={false} />;
};